import { SemanticICONS } from 'semantic-ui-react';
import { ActionType } from 'typesafe-actions';

export enum AlertLevel {
    SUCCESS = 'success',
    INFO = 'info',
    WARNING = 'warning',
    ERROR = 'error',
    GREY = '',
}

export interface LinkAlert {
    text: string;
    url?: string;
    action?: ActionType<any>;
    nonLinkText?: string;
}

export interface Alert {
    key: string;
    info: string;
    instructions?: string[];
    level: AlertLevel;
    payload?: any;
    link?: LinkAlert;
    icon?: SemanticICONS;
    loading?: boolean;
    disregardAPINameInCaption?: boolean;
    api?: string;
    delay?: number;
}
